import { NgModule } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ToastComponent } from './toast/toast.component';
import { MessageService as PrimeToastService } from 'primeng/api';
import { ListboxModule } from 'primeng/listbox';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { CarouselModule } from 'primeng/carousel';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { SkeletonModule } from 'primeng/skeleton';
import { CheckboxModule } from 'primeng/checkbox';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { Drawer } from 'primeng/drawer';
import { NgIf } from '@angular/common';
import { PipeModule } from '@shared/pipe/pipe.module';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    ToastModule,
    ListboxModule,
    PasswordModule,
    CarouselModule,
    DividerModule,
    Drawer,
    FileUploadModule,
    InputNumberModule,
    MultiSelectModule,
    SkeletonModule,
    CheckboxModule,
    PanelModule,
    TableModule,
    DatePicker,
    ButtonModule,
    MessageModule,
    TooltipModule,
    NgIf,
    PipeModule
  ],
  exports: [
    ToastComponent,
    ListboxModule,
    PasswordModule,
    DividerModule,
    Drawer,
    CarouselModule,
    FileUploadModule,
    InputNumberModule,
    MultiSelectModule,
    SkeletonModule,
    CheckboxModule,
    PanelModule,
    TableModule,
    DatePicker,
    ButtonModule,
    MessageModule,
    TooltipModule
  ],
  declarations: [
    ToastComponent
  ],
  providers: [
    PrimeToastService
  ]
})
export class PrimeModule { }
